import StyledTag from './StyledTag'

export default StyledTag
